import bold from './bold'
import italic from './italic'
import underline from './underline'
import strikethrough from './strikethrough'
import alignLeft from './alignLeft'
import alignCenter from './alignCenter'
import alignRight from './alignRight'
import orderedList from './orderedList'
import unorderedList from './unorderedList'
import hr from './hr'
import eraser from './eraser'
import image from './image'

export default [
  bold,
  italic,
  underline,
  strikethrough,
  hr,
  alignLeft,
  alignCenter,
  alignRight,
  orderedList,
  unorderedList,
  image,
  eraser
]
